import React from "react";

import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { achievementCategoryAddModalStore } from "../stores/achievementCategoryAddModal";
import Container from "@cloudscape-design/components/container";
import FormField from "@cloudscape-design/components/form-field";
/* ------- */

class AchievementCategoryAddModal extends React.Component {
	state = { loading: false };
	addCategory() {
		this.setState({ loading: true });
		this.props.Interface.request("set", {
			class: "data",
			module: "achievementCategory",
			method: "create"
		}, { ...this.props.categoryAddModal, type: this.props.categoryAddModal.type.value, active: this.props.categoryAddModal.active.value}).then((result) => {
			this.props.Interface.addNoty("Success", "Achievement category was successfully created");
			this.props.setAddModalCategory({ ...this.props.categoryAddModal, type: "", name: "", show: false });
			this.props.Interface.loadAchievementCategoryList();
		}).catch((error) => {
			if (typeof error.text === "undefined") error = { text: error.toString() };
			this.props.setAddModalCategory({ ...this.props.categoryAddModal, loaded: true, error });
			this.setState({ loading: false });
		})
	}

	render() {
		return (
			<>
				<Modal
					visible={this.props.categoryAddModal.show}
					onDismiss={() => {
						this.props.setAddModalCategory({ ...this.props.categoryAddModal, loaded: true, show: false, name: "", type: "" });
					}}
					header="Add category"
					children={
						<Container>
							<SpaceBetween direction="vertical" size="m">
								<FormField label="Category name" description="Translation key" stretch>
									<Input
										autoFocus="true"
										name="name"
										autoComplete="off"
										inputMode="url"
										type="text"
										disableBrowserAutocorrect={true}
										placeholder="name"
										value={this.props.categoryAddModal.name}
										onChange={(input) => {
											this.props.setAddModalCategory({ ...this.props.categoryAddModal, name: input.detail.value });
										}}
									/>
								</FormField>
								<FormField label="Category type" description="Type of category" stretch>
									<Select
										filteringType="auto"
										placeholder="Type"
										selectedOption={this.props.categoryAddModal.type}
										onChange={(option) => {
											option.detail.selectedOption.type !== this.props.categoryAddModal.type &&
											this.props.setAddModalCategory({ ...this.props.categoryAddModal, type: option.detail.selectedOption});
										}}
										options={this.props.categoryAddModal.currentOptions.type}
									/>
								</FormField>
								<FormField label="Active" stretch>
									<Select
										selectedOption={
											this.props.categoryAddModal.active
										}
										onChange={({ detail }) =>
											this.props.setAddModalCategory({
												...this.props.categoryAddModal,
												active: detail.selectedOption,
											})
										}
										options={[{ value: "1", label: "Enabled" }, { value: "0", label: "Disabled" }]}
										placeholder="Select active"
									/>
								</FormField>
							</SpaceBetween>
						</Container>
					}
					footer={
						<>
							<Box
								float="right"
								children={
									<>
										<Box
											variant="span"
											margin={{ right: "s" }}
											children={
												<Button
													variant="normal"
													disabled={this.state.loading}
													onClick={() => {
														this.props.setAddModalCategory({ ...this.props.categoryAddModal, show: false });
													}}
													children="Close"
												/>
											}
										/>
										<Box
											variant="span"
											children={
												<Button
													loading={this.state.loading}
													disabled={this.state.loading || typeof this.props.categoryAddModal.type.value === "undefined" || typeof this.props.categoryAddModal.active.value === "undefined" || this.props.categoryAddModal.name.length === 0}
													variant="primary"
													onClick={() => {
														this.addCategory();
													}}
													children="Ok"
												/>
											}
										/>
									</>
								}
							/>
						</>
					}
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const categoryAddModal = useRecoilValue(achievementCategoryAddModalStore);
		const setAddModalCategory = useSetRecoilState(achievementCategoryAddModalStore);

		return <Component {...props}  categoryAddModal={categoryAddModal} setAddModalCategory={setAddModalCategory} />;
	};
}

export default withRecoil(AchievementCategoryAddModal);
